export default "__VITE_ASSET__5d3b67aa__"